/* eslint-disable react-hooks/exhaustive-deps */
/*eslint no-array-constructor: "off"*/
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDown } from "components/InputsMex/inputs";
import useQueryParams from "hooks/useQueryParams";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import SwitchFormContratanteAsegurado from "./SwitchFormContratanteAsegurado";

const requireRule = {
  required: "Este campo es obligatorio",
};

const FormContratanteAsegurado = ({
  title,
  catalogo,
  municipios,
  colonias,
  buscarMunicipios,
  buscarColonias,
  setColonias,
  setMunicipios,
  formulario,
}) => {
  const methods = useFormContext();
  const [loadingMunicipios, setLoadingMunicipios] = useState(false);
  const [loadingColonias, setLoadingColonias] = useState(false);
  const { validaciones } = catalogo;
  const [secciones, setSecciones] = useState([]);
  const { codProducto } = useQueryParams();
  const [catalogoTipoPersona, setCatTipoPersona] = useState(
    catalogo?.tipoPersona?.map((e) => ({
      label: e.label,
      value: e,
    }))
  );

  const [precargando, SetPrecargando] = useState(false);

  useEffect(() => {
    const mappedSecciones = catalogo?.agrupaciones
      ?.filter((seccion) => {
        if (seccion.hasOwnProperty("formulario") && seccion.formulario !== formulario) {
          return false;
        }
        return true;
      })
      ?.map((seccion) => {
        seccion.campos = validaciones.filter((campo) => campo.grupo === seccion.codigo);
        return seccion;
      })
      .filter((seccion) => {
        //ESTO SE AGREGO PARA MAPEAR SOLO LOS CAMPOS DEL PRODUCTO SELECCIONADO
        const tieneCampos = seccion.campos?.length > 0;

        const camposValidos = seccion.campos.some((campo) => {
          return campo.hasOwnProperty("producto") ? campo.producto === codProducto : true;
        });

        return tieneCampos && camposValidos;
      });
    setSecciones(mappedSecciones);

    if (codProducto === PRODUCTOS.AUTO && formulario === "asegurado") {
      const setCatalogo = catalogo?.tipoPersona
        ?.filter((e) => e.value === "F")
        ?.map((e) => ({
          label: e.label,
          value: e,
        }));
      setCatTipoPersona(setCatalogo);
    }
  }, []);

  const onChangeEstado = async (estado) => {
    methods.setValue("municipio", null);
    methods.setValue("colonia", null);
    const codigoPostal = methods.watch("codigoPostal");
    methods.setValue("codigoPostal", "");
    setColonias([]);
    setMunicipios([]);
    if (estado) {
      setLoadingMunicipios(true);
      setLoadingColonias(true);
      buscarMunicipios(estado.codPais, estado.codDpto, codigoPostal).then((res) => {
        setLoadingMunicipios(false);
        setLoadingColonias(false);
      });
    }
  };

  const onChangeMunicipio = async (municipio) => {
    methods.setValue("colonia", null);
    const codigoPostal = methods.watch("codigoPostal");
    methods.setValue("codigoPostal", "");
    setColonias([]);
    if (municipio) {
      setLoadingColonias(true);
      buscarColonias(municipio, codigoPostal).then((res) => {
        setLoadingColonias(false);
      });
    }
  };

  const onChangeColonia = (colonia) => {
    methods.setValue("codigoPostal", colonia?.codPostal);
    methods.clearErrors("codigoPostal");
  };
  const onChangeLoadContratante = (value) => {
    SetPrecargando(true);
    if (
      value === "SI" &&
      catalogo.precargaInfoAsegurado &&
      methods.watch("tipoPersona") &&
      methods.watch("tipoPersona").value === "F"
    ) {
      methods.reset({
        ...catalogo.precargaInfoAsegurado,
        infAseguradoContratante: value,
      });
    } else {
      methods.reset({
        tipoPersona: methods.watch("tipoPersona"),
        infAseguradoContratante: value,
      });
    }
    setTimeout(() => {
      SetPrecargando(false);
    }, 100);
  };
  const onChangeResetForm = (obj) => {
    if (codProducto === PRODUCTOS.AUTO && obj && obj.value === "J") {
      SetPrecargando(true);
      methods.reset({
        tipoPersona: methods.watch("tipoPersona"),
      });
      setTimeout(() => {
        SetPrecargando(false);
      }, 100);
    }
  };

  return (
    <div className='row justify-content-center'>
      <div className='col-11 col-md-11 col-md-10 card-login-mex'>
        <h2
          className='font-mex mt-4 mb-3 text-mex text-center'
          style={{ fontSize: "26px" }}>
          {title}
        </h2>

        <div className='row'>
          <div className='col-11 col-lg-10'>
            <div className='form-group col-md-6 col-lg-5'>
              <SimpleContainer label='Tipo de persona' name='tipoPersona'>
                <DropDown
                  rules={{
                    ...requireRule,
                  }}
                  name='tipoPersona'
                  options={catalogoTipoPersona}
                  onChangeFn={onChangeResetForm}
                />
              </SimpleContainer>
            </div>
          </div>
          {codProducto &&
            codProducto === PRODUCTOS.AUTO &&
            methods.watch("tipoPersona") &&
            methods.watch("tipoPersona").value === "F" &&
            formulario === "contratante" && (
              <div className='col-11 col-lg-10'>
                <div className='form-group col-md-6 col-lg-5'>
                  <SimpleContainer
                    label='¿La información del asegurado es la misma que la del contratante?'
                    name='infAseguradoContratante'>
                    <DropDown
                      rules={{}}
                      name='infAseguradoContratante'
                      options={[
                        {
                          label: "SI",
                          value: "SI",
                        },
                        {
                          label: "NO",
                          value: "NO",
                        },
                      ]}
                      onChangeFn={onChangeLoadContratante}
                    />
                  </SimpleContainer>
                </div>
              </div>
            )}
        </div>

        {methods.watch("tipoPersona")?.value &&
          !precargando &&
          secciones.map(
            (seccion, index) =>
              !seccion.disabled && (
                <div key={index} className='row'>
                  <div className='col-12 ml-5'>
                    <div className='d-flex flex-row'>
                      <img
                        className='img-fluid'
                        src={seccion.urlIcono}
                        alt={seccion.label}
                        style={{ width: "40px" }}
                      />
                      <h2 className='text-primary my-auto'>{seccion.label}</h2>
                    </div>
                  </div>

                  <div className='col-12'>
                    <div className='row justify-content-center'>
                      <div className='col-md-11 col-lg-10'>
                        <div className='row justify-content-between'>
                          <SwitchFormContratanteAsegurado
                            formulario={formulario}
                            producto={codProducto}
                            campos={seccion.campos}
                            catalogo={catalogo}
                            onChanges={{
                              onChangeEstado,
                              onChangeMunicipio,
                              onChangeColonia,
                            }}
                            loadings={{ loadingMunicipios, loadingColonias }}
                            sources={{
                              municipios,
                              colonias,
                              ...catalogo?.sources,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
          )}
      </div>
    </div>
  );
};

export default FormContratanteAsegurado;
